import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./assets/css/tailwind.output.css";
import App from "./App";
import { SidebarProvider } from "./context/SidebarContext";
import { UserProvider } from './context/UserContext';
import { BranchProvider } from "./context/BranchContext";
import ThemedSuspense from "./components/ThemedSuspense";
import { Windmill } from "@windmill/react-ui";
import windmillTheme from "./windmillTheme";
import './index.css'

ReactDOM.render(
  <UserProvider>
    <BranchProvider>
      <SidebarProvider>
        <Suspense fallback={<ThemedSuspense />}>
          <Windmill usePreferences theme={windmillTheme}>
            <App />
          </Windmill>
        </Suspense>
      </SidebarProvider>
    </BranchProvider>
  </UserProvider>,
  document.getElementById("root")
);
